import { render, staticRenderFns } from "./customer.vue?vue&type=template&id=6a83cb58&"
import script from "./customer.vue?vue&type=script&lang=js&"
export * from "./customer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\project\\文化宫\\code\\whg\\Web\\Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a83cb58')) {
      api.createRecord('6a83cb58', component.options)
    } else {
      api.reload('6a83cb58', component.options)
    }
    module.hot.accept("./customer.vue?vue&type=template&id=6a83cb58&", function () {
      api.rerender('6a83cb58', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PMS/baseInformation/WuyeZiyuanManager/house/customer.vue"
export default component.exports